import type { SgBsTheme } from 'state/userPreferences/userPreferences.model';

export const toHighchartsTheme = (theme: SgBsTheme) => `highcharts-${theme}`;
export const exportMenuItems = [
  'viewFullscreen',
  'printChart',
  'separator',
  'downloadPNG',
  'downloadJPEG',
  'downloadSVG',
  'separator',
  'downloadCSV',
  'downloadXLS',
] as const;
